import React from 'react';
import Cart from 'components/features/Cart/Cart';

const CartPage = () => (
  <>
    <Cart />
  </>
);

export default CartPage;
